export default __webpack_public_path__ + "static/media/fireFN5.bf2ea60a.svg";